module.exports = __webpack_public_path__ + "img/devanom-ippo-pale-ale.20017b2c.png";